import { Injectable } from '@angular/core';
import { ServiceConfig } from 'app/_services/service-config';
import { HttpClient, HttpHeaders, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable()
export class ReportComponentService {
    private host = ServiceConfig.host;
    private url_report = this.host + '/api/ipcc/';
    private httpHeaders = new HttpHeaders({
        'Content-Type': 'application/json'
    });
    private httpParams = new HttpParams().set('token', JSON.parse(localStorage.getItem('currentSmmData')).token);

    constructor(private httpClient: HttpClient) {
    }
    getRecentPost(body): Observable<any> {
        return this.httpClient.post(`${this.url_report}/report/getRecentPost`, body, { params: this.httpParams, headers: this.httpHeaders });
    }
}


// WEBPACK FOOTER //
// D:/Project/Nodejs/SocialListening_Cloud/frontend_cloud/src/app/views/reports-component/reports-component.service.ts